export const STATIC_PAGE = {
  TERMS_AND_CONDITIONS: "terms-and-conditions",
}
